import React, {useEffect, useState} from 'react';
import {Modal, Typography, Flex, Radio, Button, theme} from 'antd';
import {v4 as uuidv4} from 'uuid';
import {useDispatch, useSelector} from 'react-redux';
import {gqlTransactionDashboardSearch} from 'GQL/MethodsBFF/ServiceRequest';
import {CustomTextInput} from 'Components';
import {gqlLinkTransaction} from 'GQL/MethodsBFF/LinkTransaction';
import {searchSRByID} from 'Redux/Slices/selectedSR';

const {Text, Title} = Typography;

interface LinkTransactionDialogProps {
  open: boolean;
  onClose: () => void;
  selectedSRId?: string;
}

const LinkTransactionDialog: React.FC<LinkTransactionDialogProps> = (props) => {
  const {open, onClose, selectedSRId} = props;
  const [claimId, setClaimId] = useState('');
  const [bookingReference, setBookingReference] = useState('');
  const loginDetails = useSelector((state: any) => state?.login);
  const [transactions, setTransactions] = useState<any>(null);
  const [selectedTransactionId, setSelectedTransactionId] = useState<string | null>(null);
  const dispatch = useDispatch();
  const {token}: any = theme.useToken();

  useEffect(() => {
    setSelectedTransactionId(null);
    setTransactions(null);
    setClaimId('');
  }, [onClose]);

  const handleLinkTransaction = async () => {
    let payload = {
      srId: selectedSRId,
      claimId: selectedTransactionId,
    };
    const headers = {
      'tenant-id': loginDetails?.tenantID,
      // 'tenant-id': 5000005,
      'x-correlation-id': uuidv4(),
      Authorization: `Bearer ${loginDetails?.loginInfo?.access_token}`,
    };
    await gqlLinkTransaction(payload, headers);
    await dispatch(
      searchSRByID({
        id: selectedSRId,
      }),
    ).unwrap();

    onClose();
  };

  const handleSearch = async () => {
    let payload = {
      tenantId: loginDetails?.tenantID,
      claimId: claimId === '' ? null : claimId,
      bookingReference: bookingReference || '',
    };
    const headers = {
      'tenant-id': loginDetails?.tenantID,
      // 'tenant-id': 5000005,
      'x-correlation-id': uuidv4(),
      Authorization: `Bearer ${loginDetails?.loginInfo?.access_token}`,
    };
    let response = await gqlTransactionDashboardSearch(payload, headers);
    console.log(response.data.getAllClaimedOffer[0].claimedOffers);
    if (response.data.getAllClaimedOffer[0].claimedOffers) {
      setTransactions(response.data.getAllClaimedOffer[0].claimedOffers);
    }
  };
  const isSearchDisabled = !claimId && !bookingReference;

  return (
    <Modal
      // Unmount content on close, as the old MUI Dialog did, so each open starts fresh.
      destroyOnHidden
      open={open}
      onCancel={onClose}
      title="Link Transaction"
      width={720}
      style={{minHeight: '70%'}}
      footer={[
        <Button key="search" onClick={handleSearch} disabled={isSearchDisabled}>
          Search
        </Button>,
        <Button key="cancel" onClick={onClose}>
          Cancel
        </Button>,
        <Button
          key="link"
          type="primary"
          onClick={handleLinkTransaction}
          disabled={!selectedTransactionId}>
          Link Transaction
        </Button>,
      ]}>
      <Text style={{color: token.colorTextSecondary}}>
        Please enter the Claim ID or Booking Reference to link the transaction.
      </Text>
      <Flex gap={16} align="flex-end" style={{marginTop: 20}}>
        <CustomTextInput
          label="Claim ID"
          name="claimId"
          inline
          onChange={(e) => setClaimId(e.target.value)}
          value={claimId}
        />

        <CustomTextInput
          label="Booking Reference"
          name="bookingReference"
          inline
          onChange={(e) => setBookingReference(e.target.value)}
          value={bookingReference}
        />
      </Flex>

      {transactions && transactions?.length ? (
        <div style={{marginTop: 24}}>
          <Title level={5} style={{margin: 0}}>
            Available Transactions
          </Title>
          <Radio.Group
            value={selectedTransactionId}
            onChange={(e) => setSelectedTransactionId(e.target.value)}
            style={{display: 'flex', flexDirection: 'column', gap: 8, marginTop: 10}}>
            {transactions?.map((transaction) => (
              <Radio
                key={transaction.id}
                value={transaction.id}
                style={{
                  border: `1px solid ${
                    selectedTransactionId === transaction.id
                      ? token.colorPrimary
                      : token.colorBorderSecondary
                  }`,
                  borderRadius: token.borderRadiusLG,
                  padding: '10px 12px',
                  margin: 0,
                }}>
                {`Transaction ID: ${transaction.id} - ${transaction.offerType} - ${transaction.status}`}
              </Radio>
            ))}
          </Radio.Group>
        </div>
      ) : null}
    </Modal>
  );
};

export default LinkTransactionDialog;
